import {EMPLOYEE} from '../../actions/employee/employeeActionTypes';

const INITIAL_STATE = {
  employeeLoading: true,
  employee: [],
  companyEmployeesList: [],
  companyEmployeesInner: {},
  companyEmployeesListLoading: true,
  companyEmployeesInnerLoading: true,
  companyEmployeesAdding: [],

  companyEmployeesListPopup: [],
  companyEmployeesListPopupLoading: true,

  employeeForReview: [],
  employeeForReviewLoading: true,

  employeeAdd: [],
  employeeAddLoading: true,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case EMPLOYEE.GET_EMPLOYEE_SUCCESS:
      return {...state, employee: action.payload.data.data, employeeLoading: false};
    case EMPLOYEE.GET_EMPLOYEE_FAIL:
      return {...state, employeeLoading: false};

    case EMPLOYEE.GET_COMPANY_EMPLOYEE_LIST_SUCCESS:
      return {...state, companyEmployeesList: action.payload.data.data, companyEmployeesListLoading: false};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_LIST_FAIL:
      return {...state, companyEmployeesListLoading: false};

    case EMPLOYEE.GET_COMPANY_EMPLOYEE_ADDING_SUCCESS:
      return {...state, companyEmployeesAdding: action.payload.data.data, employeeLoading: false};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_ADDING_FAIL:
      return {...state, employeeLoading: false};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_INNER:
      return {...state, companyEmployeesInner: {}, companyEmployeesInnerLoading: true};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_INNER_SUCCESS:
      return {...state, companyEmployeesInner: action.payload.data.data, companyEmployeesInnerLoading: false};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_INNER_FAIL:
      return {...state, companyEmployeesInnerLoading: true};

    case EMPLOYEE.GET_EMPLOYEE_FOR_REVIEW_SUCCESS:
      return {...state, employeeForReview: action.payload.data.data, employeeForReviewLoading: false};
    case EMPLOYEE.GET_EMPLOYEE_FOR_REVIEW_FAIL:
      return {...state, employeeForReview: [], employeeForReviewLoading: false};

    case EMPLOYEE.GET_COMPANY_EMPLOYEE_POPUP:
      return {...state, companyEmployeesListPopup: [], companyEmployeesListPopupLoading: true};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_POPUP_SUCCESS:
      return {...state, companyEmployeesListPopup: action.payload.data.data, companyEmployeesListPopupLoading: false};
    case EMPLOYEE.GET_COMPANY_EMPLOYEE_POPUP_FAIL:
      return {...state, companyEmployeesListPopupLoading: false};

    case EMPLOYEE.GET_EMPLOYEE_LIST_ADDING:
      return {...state, employeeAdd: [], employeeAddLoading: true};
    case EMPLOYEE.GET_EMPLOYEE_LIST_ADDING_SUCCESS:
      return {...state, employeeAdd: action.payload.data.data, employeeAddLoading: false};
    case EMPLOYEE.GET_EMPLOYEE_LIST_ADDING_FAIL:
      return {...state, employeeAddLoading: false};

    case EMPLOYEE.CLEAR_EMPLOYEE:
      return {
        ...state,
        companyEmployeesList: [],
        companyEmployeesInner: {},
        companyEmployeesAdding: [],
        companyEmployeesListLoading: true,
        companyEmployeesInnerLoading: true
      };
    default:
      return state;
  }
}
